export const environment = {
  production: false,
  platformDomain: 'dev.learnbird.lk',
  host: 'https://dev-api.learnbird.lk',
  zoomAppKey: 'IVvuH_2_TM2KgqN_PHSMNA',
  // IMPORTANT: Replace with your actual Google Client ID from Google Cloud Console
  // See GOOGLE_SIGNIN_INTEGRATION.md for setup instructions
  googleClientId:
    '1089210167368-0sdj7du05ifa1nkofh0vq8kvfe4gh0l6.apps.googleusercontent.com',
  version: '1.0.0',
  grafana: {
    appName: 'bse-website-dev',
    url: 'https://faro-collector-prod-ap-southeast-1.grafana.net/collect/9fe75418fbf9b6d1637c0d851c540ec2',
  },
  firebase: {
    apiKey: 'AIzaSyBsvB-HE541HI5uJubmWNFnKLXsM5q8mnM',
    authDomain: 'learnbird-dev.firebaseapp.com',
    projectId: 'learnbird-dev',
    storageBucket: 'learnbird-dev.firebasestorage.app',
    messagingSenderId: '1089210167368',
    appId: '1:1089210167368:web:4b9a02ed4d584ab31b687d',
    measurementId: 'G-KBGEXMEBXC',
    vapidKey:
      'BBIqkzGWhLuGIpa4cZVnETPHIq6dBRWuEHFNAgoQGBwYgsgOc20Eo6MMhYgTsnv546tc3rEy6GO2ILIYM08hJlQ',
  },
};
